<template>
    <div>
    <CCard>
        <CCardHeader class="pt-1 pb-1">
            <CRow>
                <CCol sm="8">
                    <span class="card-header-title">Thống kê văn bản ({{this.fromDate}} - {{this.toDate}})</span>
                </CCol>
                <CCol sm="4">
                    <CButtonGroup class="float-right mr-3">
                        <CButton
                            color="outline-warning"
                            v-for="(value, key) in ['Tháng', 'Năm']"
                            :key="key"
                            class="mx-0"
                            :pressed="value === selected ? true : false"
                            @click="changeTypeReport(value)"
                        >
                            {{value}}
                        </CButton>
                    </CButtonGroup>
                </CCol>
            </CRow>
        </CCardHeader>
        <CCardBody class="pt-2 pb-0">
            <CRow>
                <CCol sm="6">
                    <CCard  class="pb-0">
                        <CCardHeader class="text-center pt-0 pb-0">
                            <span class="card-header-title">Văn bản đi</span>
                        </CCardHeader>
                        <b-overlay
                            :show="!state.loading_send"
                            no-wrap
                            spinner-variant="success"
                            spinner-type="grow"
                            rounded="sm"
                            opacity="0.8"
                            z-index="1000"
                        />
                        <CChartBar
                            style="height:300px"
                            :datasets="data_send"
                            :options="barChartOptions" 
                        />
                    </CCard>
                </CCol>
                <CCol sm="6">
                    <CCard>
                        <CCardHeader class="text-center pt-0 pb-0">
                            <span class="card-header-title">Văn bản đến</span>
                        </CCardHeader>
                        <b-overlay
                            :show="!state.loading_receive"
                            no-wrap
                            spinner-variant="success"
                            spinner-type="grow"
                            rounded="sm"
                            opacity="0.8"
                            z-index="1000"
                        />
                        <CChartBar
                            style="height:300px"
                            :datasets="data_receive"
                            :options="barChartOptions" 
                        />
                    </CCard>
                </CCol>
          </CRow>
      </CCardBody>
    </CCard>
    </div>
</template>

<script>
import moment from "moment";
import ClientFactory from "@/api/ClientFactory";
import { CChartBar } from '@coreui/vue-chartjs'
import { mapActions } from "vuex";
const iOfficeApi = ClientFactory.get("ioffices");

export default {
    components:{
        CChartBar,
    },
    data(){
        return {
            selected: 'Tháng',
            fromDate: new Date(),
            toDate: new Date(),
            data_send:[],
            data_receive:[],
            state:{
                loading_send:false,
                loading_receive:false
            },
            barChartOptions: {
                maintainAspectRatio: false,
                legend: {
                    display: true
                },
                tooltips: {
                    callbacks: {
                        label: (tooltipItem, data) => {
                        const label = data.datasets[tooltipItem.datasetIndex].label;
                        const value = tooltipItem.yLabel.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
                        return `${label}: ${value} văn bản`
                        }
                    }
                },        
                scales: {
                yAxes: [
                    {
                    ticks: {
                        // min: -1,
                        // max: 1,
                        callback: (value) => {
                        return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
                        },
                        beginAtZero: true
                    },
                    scaleLabel: {
                        display: true
                    }
                    }
                ]
                }
            },
        }
    },
    methods: {
        ...mapActions("ui", ['loading', 'closeLoading', 'notify']),
        getSendDocuments: async function () {
            this.state.loading_send = false;
            const { data } = await iOfficeApi.getSendDocuments(this.fromDate,this.toDate);
            //console.log(data);
            let jsonSendDocuments = [
                {
                    label:['Chờ duyệt'],
                    backgroundColor:['rgb(240, 34, 40)'],
                    data:[data.data[0].DI_CHO_DUYET]
                }
                ,{
                    label:['Chờ phát hành'],
                    backgroundColor:['rgb(246, 163, 19)'],
                    data:[data.data[0].DI_CHO_PHAT_HANH]
                },
                {
                    label:['Đã phát hành'],
                    backgroundColor:['rgb(33, 146, 228)'],
                    data:[data.data[0].DI_DA_PHAT_HANH]
                }
                ,{
                    label:['Đã xem'],
                    backgroundColor:['rgb(170, 104, 234)'],
                    data:[data.data[0].DI_DA_XEM]
                },
                {
                    label:['Chưa xem'],
                    backgroundColor:['rgb(86, 196, 100)'],
                    data:[data.data[0].DI_CHUA_XEM]
                }
                ,{
                    label:['Quá hạn xử lý'],
                    backgroundColor:['rgb(198, 102, 32)'],
                    data:[data.data[0].DI_QUA_HAN_XU_LY]
                }
            ]
            this.state.loading_send = true;
            this.data_send = jsonSendDocuments;
        },
        getReceiveDocuments: async function () {
            this.state.loading_receive = false;
            const { data } = await iOfficeApi.getReceiveDocuments(this.fromDate,this.toDate);
            let jsonReceiveDocuments = [
                {
                    label:['Chưa xử lý'],
                    backgroundColor:['rgb(240, 34, 40)'],
                    data:[data.data[0].DEN_CHUA_XU_LY]
                },
                {
                    label:['Đã xử lý'],
                    backgroundColor:['rgb(33, 146, 228)'],
                    data:[data.data[0].DEN_DA_XU_LY]
                }
                ,{
                    label:['Đang xử lý'],
                    backgroundColor:['rgb(170, 104, 234)'],
                    data:[data.data[0].DEN_DANG_XU_LY]
                }
                ,{
                    label:['Quá hạn xử lý'],
                    backgroundColor:['rgb(198, 102, 32)'],
                    data:[data.data[0].DEN_QUA_HAN_XU_LY]
                }
            ]
            this.state.loading_receive = true;
            this.data_receive = jsonReceiveDocuments;
            
        },
        changeTypeReport(value){
            this.selected = value;
            var date = new Date();
            if(value === 'Năm')
            {
                this.fromDate = moment(new Date(date.getFullYear(), 0, 1)).format("DD/MM/YYYY");
                this.toDate = moment(new Date(date.getFullYear(), 12, 0)).format("DD/MM/YYYY");
            }else
            {
                this.fromDate = moment(new Date(date.getFullYear(), date.getMonth(), 1)).format("DD/MM/YYYY");
                this.toDate = moment(new Date(date.getFullYear(), date.getMonth()+1, 0)).format("DD/MM/YYYY");
            }
            this.getSendDocuments();
            this.getReceiveDocuments();
        }
    },
    async created() {
        var date = new Date();
        this.fromDate = moment(new Date(date.getFullYear(), date.getMonth(), 1)).format("DD/MM/YYYY");
        this.toDate = moment(new Date(date.getFullYear(), date.getMonth()+1, 0)).format("DD/MM/YYYY");
        this.getSendDocuments();
        this.getReceiveDocuments();
    },
    mounted() {
        
    },

    beforeMount() {

    },
    destroyed() {

    }
    
}
</script>
<style>
.a {
    background: #000000;
}
</style>